import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { SloObservationDetails } from 'src/app/model/observation/slo/slo-details.model';

@Injectable()
export class PrincipalSloApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getObservationDetails(observationId: string) {
        return this.http.get<SloObservationDetails>(this.baseUri + '/observation/principalSlo/' + observationId, {});
    }
}
